import ContractPaper from './ContractPaperContainer';

export { ContractPaper };



// WEBPACK FOOTER //
// ./src/modules/home/contractPaper/index.js